import { useEffect } from 'react'
import { switchLanguage } from 'utils/app.ts'
import { useTranslation } from 'react-i18next'
import ScrollToTop from 'components/scroll-to-top/ScrollToTop.tsx'
import { Outlet } from 'react-router'
import EnvironmentRibbon from 'components/environment-ribbon/EnvironmentRibbon.tsx'
import { IS_PRODUCTION } from 'constants/envs.ts'
import { LANGUAGES } from '@boltenergy-be/shared'
import { Helmet } from '@dr.pogodin/react-helmet'
import AppUrlListener from 'providers/app-url-listener/AppUrlListener.tsx'
import AppVersionProvider from 'providers/app-version-provider/AppVersionProvider.tsx'

const RootLayout = () => {
  // i18n
  const { t } = useTranslation()

  // Constants
  const langFromQuery = new URLSearchParams(window.location.search).get('lang')

  // Use correct lang (from URL queryparams)
  useEffect(() => {
    if (langFromQuery && (langFromQuery === LANGUAGES.NL || langFromQuery === LANGUAGES.FR)) {
      switchLanguage(langFromQuery)
    }
  }, [langFromQuery])

  return (
    <>
      <Helmet>
        {/* Favicon */}
        <link rel="icon" type="image/png" href="/favicon-96x96.png" sizes="96x96" />
        <link rel="icon" type="image/svg+xml" href="/favicon.svg" />
        <link rel="shortcut icon" href="/favicon.ico" />
        <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />
        <meta name="apple-mobile-web-app-title" content="My Bolt" />
        <link rel="manifest" href="/site.webmanifest" />

        {/* SEO */}
        <title>My Bolt</title>
        <meta property="og:image" content="https://res.cloudinary.com/bolt-energie/image/upload/v1746794752/my-bolt/seo.jpg" />
        <meta name="description" content={t(($) => $.meta.description)} />
        {!IS_PRODUCTION && <meta name="robots" content="noindex,nofollow" />}
      </Helmet>

      <ScrollToTop />
      <AppUrlListener />

      <EnvironmentRibbon />
      <AppVersionProvider>
        <Outlet />
      </AppVersionProvider>
    </>
  )
}

export default RootLayout
